import Vue from 'vue'
import moment from 'moment'

const state = {
    options: {
        since: null,
        until: null,
        pickstatus: 0,
        minutes: 0,
        shownumber: 100,
        datamode: "limit_mode",
        isActive: [0, 0, 1, 0, 0, 0, 0],
        isActive2: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        reRender: false,
        refreshflag: true
    }
}

const getters = {
    getshownumber(state) {
        return state.options.shownumber
    }
}

const mutations = {
    setSince(state, time) {
        Vue.set(state.options, "since", time)
    },
    setUntil(state, time) {
        Vue.set(state.options, "until", time)
    },
    setShowNumber(state, payload) {
        Vue.set(state.options, "shownumber", payload)
    },
    setPickstatus(state, payload) {
        Vue.set(state.options, "pickstatus", payload)
    },
    setMinutes(state, payload) {
        Vue.set(state.options, "minutes", payload)
    },
    setDatamode(state, payload) {
        Vue.set(state.options, "datamode", payload)
    },
    setIsActive(state, payload) {
        Vue.set(state.options, "isActive", payload)
    },
    setIsActive2(state, payload) {
        Vue.set(state.options, "isActive2", payload)
    },
    setRerender(state, payload) {
        Vue.set(state.options, "reRender", payload)
    },
    setrefreshflag(state, payload) {
        Vue.set(state.options, "refreshflag", payload)
    }
}

const actions = {
    setSince: ((ctx, mTime) => {
        ctx.commit('setSince', mTime)
    }),
    setUntil: ((ctx, mTime) => {
        ctx.commit('setUntil', mTime)
    }),
    clear: (ctx => {
        ctx.commit('setSince', null)
        ctx.commit('setUntil', null)
    }),
    setRelativeTime: ((ctx, min) => {
        ctx.commit('setSince', moment().subtract(min, 'minutes'))
        ctx.commit('setUntil', moment())
    }),
    setShowNumber: ((ctx, num) => {
        ctx.commit('setShowNumber', num)
    }),
    setPickstatus: ((ctx, status) => {
        ctx.commit('setPickstatus', status)
    }),
    setMinutes: ((ctx, status) => {
        ctx.commit('setMinutes', status)
    }),
    setDatamode: ((ctx, status) => {
        ctx.commit('setDatamode', status)
    }),
    setIsActive: ((ctx, status) => {
        ctx.commit('setIsActive', status)
    }),
    setIsActive2: ((ctx, status) => {
        ctx.commit('setIsActive2', status)
    }),
    setRerender: ((ctx, status) => {
        ctx.commit('setRerender', status)
    }),
    setrefreshflag: ((ctx, status) => {
        ctx.commit('setrefreshflag', status)
    })
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
